export default {
  lectorixHosts: ['lms.lectorix.net'],
  ukrainianHosts: ['lms.logikaschool.com', 'lms.logikaschool.org'],
  mexicanHosts: ['lms.algonova.mx', 'lms.algonova.lat'],
  indonesianHosts: ['lms.algonova.id']
};
